export const myObject = [
  {
    id: 1,
    name: "3 Methoxy Butanol",
    url: "https://www.celanese.com/-/media/cewebjssapp/project/images/products/3-methoxy-butanol/products_acetyls_3methoxybutanol_header.jpg",
    text: "Additives, Coatings, Solvent, Inks",
  },
  {
    id: 2,
    name: "Methoxy-Butoxyl®",
    url: "https://www.celanese.com/-/media/cewebjssapp/project/images/products/butoxyl/product_acetyls_butoxyl_header_updated.ashx",
    text: "Additives, Coatings, Solvent",
  },
  {
    id: 3,
    name: "Acetic Acid",
    url: "https://www.celanese.com/-/media/cewebjssapp/project/images/products/acetic-acid/product_acetyls_aceticacid_header.ashx",
    text: "Additives, Dyes, Frangrances",
  },
  {
    id: 4,
    name: "Acetic Anhydride",
    url: "https://www.celanese.com/-/media/cewebjssapp/project/images/products/acetic-anhydride/product-acetyls-acetic-anhydride-header.jpg",
    text: "Additives",
  },
  {
    id: 5,
    name: "Ateva Polymers",
    url: "https://www.celanese.com/-/media/cewebjssapp/project/images/products/eva-polymers/product_acetyls_eva_polymers_header-med.ashx",
    text: "Additives",
  },
  {
    id: 6,
    name: "Butyric Anhydride",
    url: "https://www.celanese.com/-/media/cewebjssapp/project/images/products/butyric-anhydride/product_acetyls_butyric_anhydride_header.jpg",
    text: "Coatings, Flexible packaging, Automotive",
  },
  {
    id: 7,
    name: "Crotonaldehyde",
    url: "https://www.celanese.com/-/media/cewebjssapp/project/images/products/crotonaldehyde/product_acetyls_crotonaldehyde_header.ashx",
    text: "Additives, Coatings, Adhesives",
  },
  {
    id: 8,
    name: "Ethyle Acetate",
    url: "https://www.celanese.com/-/media/cewebjssapp/project/images/products/ethyl-acetate/product_acetyls_ethyl_acetate_header.ashx",
    text: "Herbicide, Supplements & nutrition",
  },
];
